module.exports = __webpack_public_path__ + "static/wedding_planner1-680d540e7f320fb9377552a9981cfe9e.svg";